"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getPageNameValues = function getPageNameValues() {
  var formattedName = window.location.pathname.replace(/^\/|\/$/g, '').replace(/^(en|fr)(\/(nl|pe|ns|nb|qc|on|mb|sk|ab|bc|yt|nt|nu))?\//, '').replace(/\/account\/\w{22}(\/subscriber\/\w{22})?/g, '').replace(/\//g, '>');
  var siteSections = formattedName.split('>');
  var pageName = "telus>".concat(formattedName);
  return {
    pageName: pageName,
    siteSections: siteSections
  };
};

var _default = getPageNameValues;
exports["default"] = _default;